export const drawerboxTypes =  [
    "Antaro Grey",
    "Antaro White",
    "Legrabox Orion Grey",
    "Legrabox Orion White",
    "Bedroom (MTX)",
    "Tandem MFC",
    "Tandem Oak Dovetail"
] as const;